import { render, staticRenderFns } from "./CFActiveTasks.vue?vue&type=template&id=38b20302&"
import script from "./CFActiveTasks.vue?vue&type=script&lang=ts&"
export * from "./CFActiveTasks.vue?vue&type=script&lang=ts&"
import style0 from "./CFActiveTasks.vue?vue&type=style&index=0&id=38b20302&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports